import React from 'react';
import { FadeIn } from './FadeIn';
const cards = [{
  title: 'Judgment as a Public Good',
  description: 'Sound judgment is essential to institutional stability and long-term continuity. It is not merely a personal trait, but the foundation of civilizational survival.'
}, {
  title: 'Earned Authority',
  description: 'Leadership should be tied to demonstrated competence, not popularity alone. Power scales in exact proportion to verified cognitive and emotional discipline.'
}, {
  title: 'Developmental Citizenship',
  description: 'Citizenship is a path of growth, training, and increasing civic responsibility. The state actively invests in raising the cognitive capacity of its people.'
}, {
  title: 'Constitutional Restraint',
  description: 'Competence-based governance must remain bounded by law and due process. Strict safeguards prevent the abuse of standards as a cover for arbitrary domination.'
}];
export function WhatIsCognarchism() {
  return <section className="py-24 md:py-32 bg-cognarch-white relative border-t border-cognarch-border" data-id="element-160">
      <div className="max-w-7xl mx-auto px-6" data-id="element-161">
        <FadeIn data-id="element-162">
          <div className="flex flex-col items-center text-center mb-20" data-id="element-163">
            <div className="w-12 h-px bg-cognarch-charcoal mb-8" data-id="element-164" />
            <h2 className="text-3xl md:text-5xl font-serif mb-6 text-cognarch-charcoal" data-id="element-165">
              What Cognarchism Is
            </h2>
            <p className="text-cognarch-gray max-w-2xl text-lg" data-id="element-166">
              The foundational tenets of a competence-driven constitutional
              order.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-167">
          {cards.map((card, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-168">
              <div className="group relative h-full p-8 md:p-10 bg-cognarch-offwhite border border-cognarch-border hover:border-cognarch-charcoal/30 transition-colors duration-500 flex flex-col" data-id="element-169">
                <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-transparent to-transparent group-hover:via-cognarch-charcoal/20 transition-all duration-700" data-id="element-170" />

                <div className="text-cognarch-border font-serif text-5xl mb-6 group-hover:text-cognarch-gray transition-colors duration-500" data-id="element-171">
                  0{index + 1}
                </div>

                <h3 className="text-2xl font-serif mb-4 text-cognarch-charcoal group-hover:text-cognarch-black transition-colors duration-300" data-id="element-172">
                  {card.title}
                </h3>

                <p className="text-cognarch-gray leading-relaxed flex-grow" data-id="element-173">
                  {card.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}